// Theme main JS-file
// --------------------------------------------------------------------------------------------------------------------

// and "external-link" class name for external link
isLinkExternal = () => {
    let links = document.querySelectorAll("a");

    links.forEach((link) => {
        let a = link;
        let href = a.href;
        
        // Ignore links with URLs http://# or https://#
        if (!href || href === "http://#" || href === "https://#" || href === "https:/#" || href === "http:/#") {
            return;
        }

        // Extract hostname from the link
        let linkUrl = new URL(href);
        let linkHostname = linkUrl.hostname;
        

        // Ignore tel: or mailto: links
        if (
            linkUrl.protocol === "tel:" ||
            linkUrl.protocol === "mailto:" ||
            linkHostname === location.hostname
        ) {
            return;
        }

        // ei lisätä ikonia somelinkkien ikoneille tai kuville. poistettu smashballoon
        if (
            a.closest(".no-ext-icon") !== null ||
            a.closest(".wp-block-social-link-anchor") !== null ||
            a.closest(".sbi_photo_wrap") !== null ||
            a.closest(".sbi_header_link") !== null ||
            a.closest(".wp-block-image") !== null
        ) {
            return;
        }

        a.classList.add("is-external-link");

        a.innerHTML += `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-external-link bi-box-arrow-up-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
          </svg>`;
    });
};


function isElementInViewport(el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight ||
                document.documentElement
                    .clientHeight) /* or $(window).height() */ &&
        rect.right <=
            (window.innerWidth ||
                document.documentElement.clientWidth) /* or $(window).width() */
    );
}

// remove loading lazy atribute from first banner images and hero slider images
removeLoadingLazy = () => {
    // First image on the page content
    const firstImageOnPage = document.querySelector(".site-banner-bg img");
    if (firstImageOnPage) {
        firstImageOnPage.removeAttribute("loading");
    }

    // Swiper slider images
    const swiperImages = document.querySelectorAll(
        ".swiper .site-banner-bg img"
    );
    swiperImages.forEach((image) => {
        image.removeAttribute("loading");
    });
};

// Set default height and widt to logo image
function setLogoHeightWidth() {
    const logo = document.querySelector("#header .navbar-brand img");
    if (logo) {
        const logoHeight = logo.clientHeight;
        const logoWidth = logo.clientWidth;

        logo.setAttribute("width", `${logoWidth}`);
        logo.setAttribute("height", `${logoHeight}`);
    }
}

// Siirtää postmeta tiedot heron päälle, jos artikkelille on asetettu Hero-blockki
function postHeroImageEntryMeta() {
    //  const post = body.querySelector(".single-post");
    const postEntryHeader = document.querySelector(
        ".single-post .entry-header"
    );
    const hero = document.querySelector(".hero");
    const heroInnerContent = document.querySelector(".inner-content");

    if (hero && postEntryHeader) {
        heroInnerContent.appendChild(postEntryHeader);
    }
}

// Säädetään sivupalkin korkeutta, jos sivulla on iso pääkuva
sidebarWithHero = () => {
    const body = document.querySelector("body");
    const hero = document.body.querySelector(".hero");
    const sidebar = document.body.querySelector("#sidebar");

    if (hero && sidebar) {
        body.classList.add("page-has-hero-and-sidebar");
    }
};

  // Tabs
  const tabs = document.querySelectorAll(".tabs");

  if (tabs.length > 0) {
    tabs.forEach((tabsi) => {
        const tabsnav = tabsi.querySelector(".nav-tabs");
        const tabcontent = tabsi.querySelectorAll(".tab-content");
        const tabbutton = tabsi.querySelectorAll("button.nav-link");
        const tabpane = tabcontent[0].querySelectorAll(".tab-pane");

        tabpane[0].classList.add("active", "show");

        tabbutton[0].classList.add("active");

        tabbutton.forEach((tabb) => {
            tabsnav.appendChild(tabb);
        });
    });
}


// Lightbox - single image link to image file
const singleImgLightBox = () => {
    const imageAClass = document.querySelectorAll(".wp-block-image > a, .wp-block-image > figure > a");

    if (imageAClass.length > 0) {
        let i = 1;

        const createLightbox = (el, className) => {
            const img = el.querySelector("img");
            if (img) {
                const hrefBaseUrl = el.href.split('-')[0];
                const srcBaseUrl = img.src.split('-')[0];

                if (hrefBaseUrl === srcBaseUrl) {
                    el.classList.add(className);
                    return GLightbox({ selector: '.' + className });
                }
            }
        };

        imageAClass.forEach((el) => {
            if (!el.closest('.wp-block-gallery')) {
                const newClass = "glightboxf" + i;
                const lightbox = createLightbox(el, newClass);
                if (lightbox) {
                    i++;
                }
            }
        });
    }
};

// Lightbox - galleria
const galleryLightBox = () => {
    const galleryClass = document.querySelectorAll(".wp-block-gallery,.swiper-wrapper");

    if (galleryClass.length > 0) {
        let i = 1;

        const createLightbox = (el, className) => {
            el.classList.add(className);
            //console.log(className);
            return GLightbox({ selector: '.' + className + ' a:not(.wp-block-button__link)' });
            
        };

        galleryClass.forEach((el) => {
            console.log(el);
            const newClass = "glightbox" + i;
            createLightbox(el, newClass);
            i++;
        });
    }
};

const header = document.querySelector("#header");
const siteContent = document.querySelector(".site-content");
if (header.classList.contains("fixed-top")) {
    siteContent.classList.add("nav-bar-is-fixed");
}

// Run functions
removeLoadingLazy();
setLogoHeightWidth();
postHeroImageEntryMeta();
sidebarWithHero();
galleryLightBox();
singleImgLightBox();
isLinkExternal();

